import {useTranslation} from "react-i18next";
import {calculatePnoPercent, divideRatio} from "./reportingMetricRatios.js";
import {combineMediaSourceQualities} from "./reportingMetricPresentation.js";

const NonAggregateColumns = [
    'pnoGross',
    'pnoNet',
    'roasGross',
    'roasNet',
    'poasGross',
    'poasNet',
    'ctr',
    'cpm',
    'cpc',
    'profitPercentGross',
    'profitPercentNet',
    'conversionRateGross',
    'conversionRateNet',
];

export default function updateTotal(previous, column, value)
{
    if(value === undefined) {
        value = null;
    }

    if(previous === null || previous === undefined) {
        previous = {};
    }

    if(column.name === 'name') {
        return previous;
    }

    if(previous[column.name] === null) {
        return previous;
    }

    if(NonAggregateColumns.includes(column.name)) {
        let result = {...previous};
        result[column.name] = null;
        return result;
    }

    if(Object.keys(previous).includes(column.name)) {
        previous[column.name] = updateTotalSum(column.name, previous[column.name], value);
    } else {
        previous[column.name] = value;
    }

    return previous;
}

export function updateTotalSum(key, value1, value2) {

    if(value1 === null || value1 === undefined) {
        return null;
    }

    if(value2 === null || value2 === undefined) {
        return null;
    }

    if(
        Object.keys(value1).includes('amount')
        && Object.keys(value1).includes('currency')
        && Object.keys(value2).includes('amount')
        && Object.keys(value2).includes('currency')
    ) {
        return {...value1, amount: (parseInt(value1.amount) + parseInt(value2.amount))};
    }

    return value1 + value2;
}

export function aggregateMarketingChannelTotal(totalRow, campaigns, columns)
{
    const canonicalCampaigns = campaigns.filter((campaign) => campaign?.financeScope !== "raw_provider");
    for (const campaign of canonicalCampaigns) {
        for (const column of columns) {
            totalRow = updateTotal(totalRow, column, campaign[column.name]);
        }
    }

    totalRow.mediaSourceQuality = combineMediaSourceQualities(canonicalCampaigns.map((campaign) => campaign.mediaSourceQuality))
        ?? totalRow.mediaSourceQuality
        ?? null;

    return calculateMarketingChannelResults(totalRow);
}

export function calculateMarketingChannelResults(totalRow)
{
    totalRow.pnoNet = calculatePnoPercent(totalRow.spendMarketing?.amount, totalRow.turnoverNet?.amount, totalRow.mediaSourceQuality);
    totalRow.pnoGross = calculatePnoPercent(totalRow.spendMarketing?.amount, totalRow.turnoverGross?.amount, totalRow.mediaSourceQuality);
    totalRow.roasNet = calculateMarketingRoas(totalRow.turnoverNet, totalRow.spendMarketing, totalRow.mediaSourceQuality);
    totalRow.roasGross = calculateMarketingRoas(totalRow.turnoverGross, totalRow.spendMarketing, totalRow.mediaSourceQuality);

    return totalRow;
}

function calculateMarketingRoas(revenue, spend, mediaSourceQuality)
{
    if (
        revenue === null || revenue === undefined || spend === null || spend === undefined
        || !revenue.currency || revenue.currency !== spend.currency
        || revenue.amount === null || revenue.amount === undefined
        || spend.amount === null || spend.amount === undefined
        || !Number.isFinite(Number(revenue.amount)) || !Number.isFinite(Number(spend.amount))
        || Number(revenue.amount) < 0
    ) {
        return null;
    }

    return divideRatio(revenue.amount, spend.amount, mediaSourceQuality);
}
